var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "50px",
    viewBox: "0 0 47 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/06",
    transform: "translate(-9.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "icon-color-base",
    x: 43,
    y: 33,
    width: 7,
    height: 22,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    className: "icon-color-base",
    x: 15,
    y: 11,
    width: 7,
    height: 22,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9AE0EA",
    cx: 46.5,
    cy: 16.5,
    r: 9.5,
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#9AE0EA",
    cx: 18.5,
    cy: 47.5,
    r: 9.5,
    className: "fill-dynamic-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon06.fbb106261256848a63cb86f0a14a688b.svg";
export { ForwardRef as ReactComponent };